import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Error, Label } from "../..";
import { postAxios, putAxios } from "../../../Services/commonService";
import { API_PERMISSION } from "../../../../utils/api/ApiConstant";
import { PermissionSchema } from "../../../Schema/Configuration/PermissionSchema";
import { lowerFirstLetterUsingRegex } from "../../../helper/common";
import {
  sanitizeKeyInput,
  sanitizeNameInput,
} from "../../../../utils/inputUtils";

const PermissionModal = ({ handleModalHide, rowData, fetchData }) => {
  const isEdit = !!rowData.id;

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm({
    defaultValues: {
      name: rowData?.name ?? "",
      key: rowData?.key ?? "",
    },
    resolver: yupResolver(PermissionSchema),
  });

  const handleFormSubmit = async (formValues) => {
    const payload = { ...formValues };
    const url = `${API_PERMISSION}${isEdit ? "/" + rowData?.id : ""}`;
    const method = isEdit ? putAxios : postAxios;

    if (isEdit) {
      payload.isActive = rowData?.isActive;
      payload.rowVersion = rowData?.rowVersion;
    }

    const res = await method(url, payload);

    if (res?.success) {
      fetchData();
      handleModalHide();
      return;
    }

    res?.errors?.forEach((element) => {
      const field = lowerFirstLetterUsingRegex(element?.field);
      if (field)
        setError(field, {
          type: "manual",
          message: element.message,
        });
    });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <fieldset disabled={isSubmitting}>
        <div className="row ">
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="name" className="form-label" isRequired={true}>
                Name
              </Label>
              <input
                className="form-control"
                type="text"
                id="name"
                placeholder="Enter name"
                autoFocus={true}
                disabled={isSubmitting}
                tabIndex={1}
                {...register("name", {
                  onChange: (e) => {
                    e.target.value = sanitizeNameInput(e.target.value);
                  },
                })}
              />
              {errors.name && <Error>{errors.name.message}</Error>}
            </div>
          </div>
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="key" className="form-label" isRequired={true}>
                Key
              </Label>
              <input
                className="form-control"
                type="text"
                id="key"
                placeholder="Enter key"
                disabled={isSubmitting}
                tabIndex={2}
                {...register("key", {
                  onChange: (e) => {
                    e.target.value = sanitizeKeyInput(e.target.value);
                  },
                })}
              />
              {errors.key && <Error>{errors.key.message}</Error>}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end w-100 mt-3">
          <Button
            type="button"
            className="btn btn_main btn_muted px-3 py-2 mx-1"
            onClick={handleModalHide}
            tabIndex={4}
          >
            Close
          </Button>
          <Button
            type="submit"
            className="btn btn_main px-3 py-2 mx-1"
            tabIndex={3}
            isDisabled={isSubmitting}
          >
            {isSubmitting ? "Loading.." : isEdit ? "Update" : "Create"}
          </Button>
        </div>
      </fieldset>
    </form>
  );
};

export default PermissionModal;
